import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {CockpitCard} from 'shared/dtos/cockpit-card';
import {CockpitKontrolleM1} from 'shared/dtos/cockpit-kontrolle/cockpit-kontrolle';
import {ModellvariantenM1} from 'shared/dtos/cockpit-kontrolle/modellvarianten-m1';
import {DataStorageService} from 'shared/services/data-storage.service';
import {TableExportService} from 'shared/services/table-data-export/table-data-export.service';
import {CockpitContentComponent} from '../../../cockpit-shared/cockpit-content-component';
import {ModellvariantenDrrTableComponent} from './modellvarianten-drr-table/modellvarianten-drr-table.component';
import {ModellvariantenKoeffizienteComponent} from './modellvarianten-koeffiziente/modellvarianten-koeffiziente-table.component';
import {ModellvariantenRegressionOutputTableComponent} from './modellvarianten-regression-output-table/modellvarianten-regression-output-table.component';

@Component({
  selector: 'app-modellvarianten',
  templateUrl: './modellvarianten.component.html',
  styleUrl: './modellvarianten.component.scss',
  standalone: false
})
export class ModellvariantenComponent
  implements OnInit, CockpitContentComponent
{
  @ViewChild(ModellvariantenRegressionOutputTableComponent, {read: ElementRef})
  regressionOutputComponent!: ElementRef;
  @ViewChild(ModellvariantenKoeffizienteComponent, {read: ElementRef})
  koeffizienteTableComponent!: ElementRef;
  @ViewChild(ModellvariantenDrrTableComponent, {read: ElementRef})
  drrTableComponent!: ElementRef;

  card: CockpitCard;
  data: ModellvariantenM1;

  tableHeaders?: string[];
  exportCockpit?: () => void;

  constructor(
    private readonly storage: DataStorageService,
    private readonly exportService: TableExportService
  ) {}

  async ngOnInit() {
    this.data = (
      (await this.storage.getCockpitKontrolle()) as CockpitKontrolleM1
    ).modellvarianten;
  }

  exportRegressionOutput() {
    this.exportService.exportHtmlTableInElement(
      this.regressionOutputComponent.nativeElement,
      this.card.title
    );
  }

  exportKoeffizienteTable() {
    this.exportService.exportHtmlTableInElement(
      this.koeffizienteTableComponent.nativeElement,
      this.card.title
    );
  }

  exportDrrTable() {
    this.exportService.exportHtmlTableInElement(
      this.drrTableComponent.nativeElement,
      'm1.sprint8.cockpit-kontrolle.modellvarianten.drr-header'
    );
  }
}
